import React from "react";

const ComingSoon = ()=>{


return(
<div className="life-saving">

<h1 className="coming-soon"> Coming Soon . . . </h1>



</div>
)
}

export default ComingSoon;